/**
 * Shows a product added badge
 * @param {number} clientX
 * @param {number} clientY
 *
 */
export default function showProductAddedPopup(clientX, clientY) {
    Object.assign(document.getElementById('added-to-inquiry-popup').style, {
        left: `${clientX}px`,
        top: `${clientY}px`,
        display: `block`,
    });

    setTimeout(function() {
        document.getElementById('added-to-inquiry-popup').removeAttribute('style');
    }, 2000);
}
